// Production backend URL
// You can override this without code changes by setting REACT_APP_API_BASE_URL.
const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5001"

export default baseUrl